import { Cartesian3, Math as CesiumMath } from "cesium";
import { Polyline3DEntity } from "../services/entity-editors/map-entities-editor.service";

export function arePolyline3DEntitiesPositionsEqual(left: Polyline3DEntity, right: Polyline3DEntity): boolean {
    if (left.positions.length !== right.positions.length) {
        return false;
    }

    if (left.bufferWidths.some((bufferWidth, index) => bufferWidth !== right.bufferWidths[index])) {
        return false;
    }

    for (let index = 0; index < left.positions.length; index++) {
        if (!Cartesian3.equalsEpsilon(left.positions[index], right.positions[index], CesiumMath.EPSILON6)) {
            return false;
        }
    }

    return true;
}
